import React from 'react';
import {
  AiFillLinkedin,
  AiFillTwitterCircle,
  AiOutlineGithub,
  AiOutlineInstagram,
} from 'react-icons/ai';
import { FaFacebook } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer>
      <div className="flex gap-7 justify-center items-center">
        <a
          href="https://github.com/phrubel"
          className="social-icon"
          target="_blank"
          rel="noreferrer"
        >
          <AiOutlineGithub />
        </a>

        <a
          href="https://www.linkedin.com/in/parvezhasanrubel/"
          className="social-icon"
          target="_blank"
          rel="noreferrer"
        >
          <AiFillLinkedin />
        </a>
        <a
          href="https://twitter.com/phrubel42"
          className="social-icon"
          target="_blank"
          rel="noreferrer"
        >
          <AiFillTwitterCircle />
        </a>
        <a
          href="https://www.instagram.com/phrubel42/"
          className="social-icon"
          target="_blank"
          rel="noreferrer"
        >
          <AiOutlineInstagram />
        </a>
        <a
          href="https://www.facebook.com/parvezhasanrubel42/"
          className="social-icon"
          target="_blank"
          rel="noreferrer"
        >
          <FaFacebook />
        </a>
      </div>
      <div className="flex justify-center items-center mt-2">
        <p className="text-white justify-center items-center">
          &copy; {new Date().getFullYear()}
          <span className="text-primary mx-1">Parvez Hasan Rubel</span> | All
          Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
